import { React, useState, useEffect } from "react";
import PopUpCRResults from "../../client/tp-studio/tp_plain_result/chickenRoad";
import PopUpAviatorResults from "../../client/tp-studio/tp_plain_result/aviator";
import PopUpTeenpattiResults from "../../client/tp-studio/tp_plain_result/teenpatti";
import PopUpRouletteResults from "../../client/tp-studio/tp_plain_result/roulette";
import PopUpSicboResults from "../../client/tp-studio/tp_plain_result/sicbo";
import PopUpAndarBaharResults from "../../client/tp-studio/tp_plain_result/andar_bahar";
import PopUpHighLowResults from "../../client/tp-studio/tp_plain_result/hilo";
import PopUpSevenUpdownResults from "../../client/tp-studio/tp_plain_result/lucky7";
import PopUpAmAkAnResults from "../../client/tp-studio/tp_plain_result/aaa";
import PopUpSuperOvert20Results from "../../client/tp-studio/tp_plain_result/superoverT20";
import PopUp32CardResults from "../../client/tp-studio/tp_plain_result/card32";
import PopUpBCasinoResults from "../../client/tp-studio/tp_plain_result/bollywoodcasino";
import PopUpRace17Results from "../../client/tp-studio/tp_plain_result/race17";
import PopUpRace20Results from "../../client/tp-studio/tp_plain_result/race20";
import PopUpHighcardResults from "../../client/tp-studio/tp_plain_result/highcard";
import PopUpCasinowarResults from "../../client/tp-studio/tp_plain_result/casinowar";
import PopUpLucky7secResults from "../../client/tp-studio/tp_plain_result/lucky7sec";
import PopUpCentercardResults from "../../client/tp-studio/tp_plain_result/centercard";
import PopUptrioResults from "../../client/tp-studio/tp_plain_result/trio";
import PopUpTrappResults from "../../client/tp-studio/tp_plain_result/trap";
import PopUpOneCardmeterResults from "../../client/tp-studio/tp_plain_result/onecardmeter";
import PopUpOnecard2020Results from "../../client/tp-studio/tp_plain_result/onecard2020";
import PopUpQueenraceResults from "../../client/tp-studio/tp_plain_result/queenrace";
import PopUpHeadtailResults from "../../client/tp-studio/tp_plain_result/headtail";
import PopUplotteryResults from "../../client/tp-studio/tp_plain_result/lottery";
import PopUpDusDumResults from "../../client/tp-studio/tp_plain_result/10kadum";
import PopUprpsResults from "../../client/tp-studio/tp_plain_result/rps";
import PopUpdragontigerResults from "../../client/tp-studio/tp_plain_result/dragontiger";
import PopUpdreamCatcherResults from "../../client/tp-studio/tp_plain_result/dreamcatcher";

const PopUpTPResults = ({ resultsData, catMid, marketType }) => {
  const resultData = resultsData;

  useEffect(() => {
    console.log("Market Type:", marketType);
    console.log("Results Data:", resultsData);
  }, [resultsData, marketType]);

  if (!resultsData) return null;

  const dataObj = resultsData;

  const win1 = dataObj.rnr1_status;
  const win2 = dataObj.rnr2_status;
  const win3 = dataObj.rnr3_status;
  const win4 = dataObj.rnr4_status;
  let shownCard = "1";

  let Andar = "";
  let Bahar = "";
  let dice1 = "";
  let dice2 = "";
  let diceTotal = "";
  let rollDiceMarkets = [];
  let rollDiceWinner = "";
  let rouletteMarkets = [];
  let rouletteWinner = "";

  if (marketType == 24) {
    if (resultData?.result == 2) {
      Andar = "Winner";
      Bahar = "LOSER";
    } else if (resultData?.result == 1) {
      Andar = "LOSER";
      Bahar = "Winner";
    }
  }

  if (marketType == 12) {
    dice1 = resultData.result;
    dice2 = resultData.result2;
    diceTotal = resultData.result_total || resultData.resultTxt;
    rollDiceMarkets = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    rollDiceWinner = Number(diceTotal);
  }

  if (marketType == 10) {
    rouletteMarkets = [resultData.cat_rnr1, resultData.cat_rnr2].filter(
      Boolean
    );

    rouletteWinner =
      resultData.result === 1
        ? "Red"
        : resultData.result === 2
          ? "Black"
          : "Green"; // 0 on roulette
  }

  const bgCls1 = win1 === "WINNER" ? "bgwinner" : "bgLoser";
  const bgCls2 = win2 === "WINNER" ? "bgwinner" : "bgLoser";
  const bgCls3 = win3 === "WINNER" ? "bgwinner" : "bgLoser";
  const bgCls4 = win4 === "WINNER" ? "bgwinner" : "bgLoser";

  const tdCls1 = win1 === "WINNER" ? "TdResultsWin" : "";
  const tdCls2 = win2 === "WINNER" ? "TdResultsWin" : "";
  const tdCls3 = win3 === "WINNER" ? "TdResultsWin" : "";
  const tdCls4 = win4 === "WINNER" ? "TdResultsWin" : "";

  const cardsArr = dataObj.cards_desc?.split(",");
  const rnr1Arr = dataObj.rnr1_desc?.split(",");
  const rnr2Arr = dataObj.rnr2_desc?.split(",");
  const rnr3Arr = dataObj.rnr3_desc?.split(",");
  const rnr4Arr = dataObj.rnr4_desc?.split(",");

  const tableStyle = { width: "100%", borderCollapse: "collapse" };
  const rowFlexStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    background: "transparent"
  };
  const tdResultsStyle = {
    padding: 8,
    minWidth: 180,
    boxSizing: "border-box"
  };
  const playerCardsStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowWrap: "break-word"
  };
  const playerNameStyle = {
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  const cardImagesStyle = {
    display: "flex",
    justifyContent: "center",
    gap: 3,
    flexWrap: "wrap",
    width: "100%"
  };
  const cardImgStyle = {
    width: 40,
    height: 60,
    objectFit: "cover",
    borderRadius: 5
  };
  const playerStatusStyle = {
    color: "#000",
    marginTop: 5,
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };

  const AndarBaharcards = resultData?.cards_desc?.split(",") || [];
  const andarCards = AndarBaharcards.filter((_, i) => i % 2 === 0);
  const baharCards = AndarBaharcards.filter((_, i) => i % 2 !== 0);

  //const AndarBaharcard = resultData?.cards_desc?.split(",");
  return (
    <div>
      <div id="ResultsData">
        <div class="left-content site_family">
          <div id="aviator/X">
            {(marketType == 51 || marketType == 11) && (
              <PopUpAviatorResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="chickenroad">
            {marketType == 60 && (
              <PopUpCRResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="tp20/muflis">
            {(marketType == 17 || marketType == 25) && (
              <PopUpTeenpattiResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="roulette">
            {marketType == 10 && (
              <PopUpRouletteResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="sicbo">
            {marketType == 27 && (
              <PopUpSicboResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="andarbahar">
            {marketType == 24 && (
              <PopUpAndarBaharResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="hilo">
            {marketType == 13 && (
              <PopUpHighLowResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="lucky7">
            {marketType == 15 && (
              <PopUpSevenUpdownResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="aaa">
            {marketType == 23 && (
              <PopUpAmAkAnResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="superOver">
            {marketType == 58 && (
              <PopUpSuperOvert20Results
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="32card">
            {marketType == 18 && (
              <PopUp32CardResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="bollywood-casino">
            {marketType == 19 && (
              <PopUpBCasinoResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="race17">
            {marketType == 28 && (
              <PopUpRace17Results
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="race20">
            {marketType == 31 && (
              <PopUpRace20Results
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="highcard">
            {marketType == 20 && (
              <PopUpHighcardResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="casino-war">
            {marketType == 21 && (
              <PopUpCasinowarResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="lucky7-sec">
            {marketType == 26 && (
              <PopUpLucky7secResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="center-card">
            {marketType == 45 && (
              <PopUpCentercardResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="trio">
            {marketType == 55 && (
              <PopUptrioResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="trap">
            {marketType == 56 && (
              <PopUpTrappResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="one-card-2020">
            {marketType == 57 && (
              <PopUpOnecard2020Results
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="one-card-meter">
            {marketType == 54 && (
              <PopUpOneCardmeterResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="queen-race">
            {marketType == 59 && (
              <PopUpQueenraceResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="head-tail">
            {marketType == 14 && (
              <PopUpHeadtailResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="lottery">
            {marketType == 53 && (
              <PopUplotteryResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="10dum">
            {marketType == 46 && (
              <PopUpDusDumResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="rock-paper-scissors">
            {marketType == 61 && (
              <PopUprpsResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="dream-catcher">
            {marketType == 42 && (
              <PopUpdreamCatcherResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          <div id="dragon-tiger">
            {marketType == 16 && (
              <PopUpdragontigerResults
                resultsData={resultsData}
                catMid={catMid}
                marketType={marketType}
              />
            )}
          </div>

          {/*<div id="roll-dice" style={{ display: marketType == 12 ? "" : "none" }}>
            <div className="left-content">
              <div className="card">
                <div className="card-header">
                  {dataObj.evt_od} -
                  (<b>Round Id = </b>{catMid})
                </div>
                <div className="card-body">
                  <div style={{ textAlign: "center" }}>
                    <h3 style={{ marginBottom: "20px" }}>
                      {resultData.evt_evt}
                    </h3>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "15px",
                        marginBottom: "25px",
                      }}
                    >
                      <div className="diceofresults">
                        {dice1}
                      </div>
                      <div className="diceofresults">
                        {dice2}
                      </div>
                    </div>
                    <div style={{ marginTop: "35px" }}>
                      {rollDiceMarkets.map((number) => {
                        const winner = number === rollDiceWinner;
                        return (
                          <div
                            key={number}
                            style={{
                              textAlign: "center",
                              marginBottom: "18px"
                            }}
                          >
                            <div
                              style={{
                                fontSize: "22px",
                                fontWeight: "700"
                              }}
                            >
                              {number}
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: winner ? "#28a745" : "#666",
                                textTransform: "uppercase"
                              }}
                            >
                              {winner ? "WINNER" : "LOSER"}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>*/}

          {/*<div id="big-small" style={{ display: marketType == 30 ? "" : "none" }}>
            <div className="left-content">
              <div className="card">
                <div className="card-header">
                  {dataObj.evt_od} -
                  (<b>Round Id = </b>{catMid})
                </div>
                <div className="card-body">
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px 0"
                    }}
                  >
                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: "700",
                        marginBottom: "15px"
                      }}
                    >
                      Winning Number
                    </div>
                    <div
                      style={{
                        width: "80px",
                        height: "80px",
                        margin: "0 auto",
                        border: "2px solid #333",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "42px",
                        fontWeight: "700",
                        color: "#cf8d2e",
                        boxShadow: "0 0 8px rgba(0,0,0,.25)"
                      }}
                    >
                      {resultData.result_number || resultData.resultTxt || resultData.result}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>*/}
        </div>
      </div>
      <style>{`

        body{
          font-size:13px;
        }
        .player-item {
            margin-bottom: 16px;
            display: block;
            margin-right: 0;
            z-index: 0;
        }

          .player-card {
            border-radius: 12px;
            border: 1px solid rgb(14 99 8 / 25%);
          }

        .card{
            border-radius: 12px;
            padding:8px;
            margin:auto;
            border: 1px solid rgb(14 99 8 / 25%);
        }

        .BFBCardFanViewab {
            flex-wrap: wrap;
        }


        .RSMImageView2ab {
            padding: 3px;
            display:contents;
        }

        .BFBCardHandViewDealerab {
            transform: translate3d(0,0,0);
            width: 100%;
            height: auto;
            text-align: center;
        }

        .diceofresults {
            width: 75px;
            height: 75px;
            border: 1px solid black;
            border-radius: 15px;
            margin: 0px 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 45px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
            color: red;
        }
        .TdResults {
            padding: 0;
            vertical-align: top;
            flex: 1 1 auto;
            box-sizing: border-box;
            max-width: calc(33.33% - 20px);
            min-width: 120px;
            background: linear-gradient(#535353, #0f0f0f);
            border-radius: 10px;
            margin: 1px;
        }
        .bgwinner {
            border-radius: 10px;
            background-color: #cf8d2e !important;
        }
        .bgLoser {
            border-radius: 10px;
            background-color: #cf3f3f !important;
        }
        .TdResultsWin {
            background: #008000 !important;
        }
        .cards {
            border-width: 1px;
            border-style: solid;
            padding: 5px;
            background-color: #f8f8f8;
            border-color: #dbdbdb;
        }
        .font-blackAve {
          font-weight: 900;
      }
      .text-strokeAve {
        text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    }
    .tracking-wideAve {
      letter-spacing: .025em;
  }
  .text-rose-600Ave {
    color: rgb(225, 29, 72, 1) !important;
}
.flex-colAve {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.text-strokeblackAve {
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}
.gap-1Ave {
  gap: .25rem;
}
.items-endAve {
  align-items: flex-end;
}
.flexAve {
  display: flex;
}

.dream-runner .runner-disabled {
    margin-left: auto;
}

.sicbo-result-row{
    text-align:center;
    margin-bottom:18px;
}

.sicbo-market{
    font-size:20px;
    font-weight:700;
    color:#222;
    line-height:1.2;
}

.sicbo-status{
    font-size:14px;
    font-weight:600;
    margin-top:3px;
    text-transform:uppercase;
}

    #race20 .player-card,
    #race17 .player-card,
    #casino-war .player-card,
    #center-card .player-card, 
    #trio .player-card, 
    #trap .player-card,
    #one-card .player-card,
    #head-tail .player-card,
    #high-card .player-card,
    #dus-ka-dum .player-card,
    #lottery-virtual .player-card,
    #one-meter-card .player-card,
    #dragon-tiger .player-card,
    #andar-bahar .player-card,
    #bollywood .player-card,
    #queen-race .player-card,
    #super-over .player-card {
    background: none;
    padding: 0 !important;
}
      `}</style>
    </div>
  );
};

export default PopUpTPResults;